import { useAuth } from "../../../usercontext";
import GlobalGradeList from "../../pages/common/globalgradelist";
import GlobalGoalQuestions from "../../pages/common/globalgoalquestions";
import GlobalCollegeList from "../../pages/common/globalcollegelist";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import Recommendation from "../../instructor/studentGrid/sublist/academicAssessmentTables/Recommendation";
import ScoreTable from "../../instructor/studentGrid/sublist/academicAssessmentTables/ScoreTable";
import Colleges from "../../instructor/studentGrid/sublist/colleges";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentGoalQuestionsList() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent911 = profile?.role === 'Student911'
	return (
		<>
			{!isStudent911 && <STopMenu slug={slug} activeMenu="GoalQuestionsList" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="GoalQuestionsList" />}
			<PageNotes type={'Student'} studentId={slug} />

			<div className="col-md-12">
				<div className="col">
					{/* <GlobalGradeList slug={slug} /> */}
					<ScoreTable slug={slug} />
				</div>
				<Recommendation slug={slug} isStudent={true} />
				{/* <GlobalGoalQuestions slug={slug} /> */}
				{/*<Colleges slug={slug} />*/}
				<GlobalCollegeList slug={slug} isStudent={true} />
			</div>
		</>
	)
}
